import { c as _c } from "react/compiler-runtime";
import { createGermanNumberFormatter } from '@utils/utils-format';
export function RatingValue(t0) {
  const $ = _c(7);
  const {
    rating,
    className
  } = t0;
  let t1;
  let t2;
  if ($[0] !== className || $[1] !== rating) {
    const numberFormatter = createGermanNumberFormatter({
      style: "decimal",
      minimumFractionDigits: 1,
      maximumFractionDigits: 1
    });
    t1 = className;
    t2 = numberFormatter.format(rating);
    $[0] = className;
    $[1] = rating;
    $[2] = t1;
    $[3] = t2;
  } else {
    t1 = $[2];
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t1 || $[5] !== t2) {
    t3 = <span className={t1}>{t2}</span>;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
}